import { useContext } from 'react';

import { FlowRendererContext } from 'contexts/FlowRenderer';

const useFlowRenderer = () => {
  return useContext(FlowRendererContext);
};

export default useFlowRenderer;
